import { IMPERSONATION_LOCAL_STORAGE_KEY } from '@hooks/useImpersonation.ts';

export const getImpersonatedCarrierData = (field: string) => {
	const impersonatedCarrierData = sessionStorage.getItem(IMPERSONATION_LOCAL_STORAGE_KEY.carrier);
	if (!impersonatedCarrierData) {
		return null;
	}
	const data = JSON.parse(impersonatedCarrierData);
	return data[field] ?? null;
}